'use strict';
import {Injectable} from 'ng-metadata/core';
const isArray = require('lodash/isArray');

@Injectable()
export class JsonUtils {
    private arrayCache:Object;
    constructor(){
        // a cache for strings which should be converted to arrays.
        // This is an ugly solution which should be removed as this patches
        // problems in parsing and the fix should be made in parsing
         this.arrayCache = {};
    }
   /**
    * @ngdoc method
    * @name toArray
    * @methodOf starter.service: jsonUtils
    * @description
    * Checks if the provided input is array. If it is array it returns it as is. If not the string is wrapped into an array and returned. If not it is wrapped and cached.
    * This function is a helper function which is not in place. This is a workaround which helps for the template to handle mixed inputs of strings and arrays. Instead of this function the parsing should be fixed.
    *
    * @param {string}  elem The input type
    * @param {string}  split Optional parameter. If present and the input is a string, the string is splitted and the resulting array is returned.
    * @returns {array} The resulting array
    */
   toArray(elem, split) {
       if (isArray(elem)) {
           return elem;
       }
       if (elem === null || elem === undefined) {
           return [];
       }
       if (!this.arrayCache[elem]) {
           if (elem && split) {
               this.arrayCache[elem] = elem.split(';');
           } else {
               this.arrayCache[elem] = [elem];
           }

       }
       return this.arrayCache[elem];
   }

   /**
    * @ngdoc method
    * @name convertObjectToArray
    * @methodOf starter.service: jsonUtils
    * @description
    * Checks if the provided input is array. If it is array it returns it as is. If not the Object is wrapped into an array and returned.
    *
    * @param {Objext}  elem The input object         *
    * @returns {array} The resulting array
    */
   convertObjectToArray(elem) {
       if (!(elem instanceof Array)) {
           if (elem) {
               elem = [elem];
           } else {
               elem = [];
           }

       }
       return elem;
   }

}




// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/jsonUtils.service.ts